import React, {useEffect} from 'react';
import {Button, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../store';
import {AsyncTaskStatusType} from '../../shared/dtos';
import ErrorText from '../../components/ErrorText';
import CustomDialog from '../../components/CustomDialog';
import {removeFileFromContractAction} from "../../api/contract";
import {setRemoveFileFromContractTaskStatus} from "../../features/contracts/contractSlice";

interface DeleteContractFileDialogProps {
    handleClose: () => void;
    handleDelete: () => void;
    contractId: number;
    fileId: number;
    fileName: string;
}

export const DeleteContractFileDialog: React.FC<DeleteContractFileDialogProps> = ({
                                                                                  handleClose,
                                                                                  handleDelete,
                                                                                  contractId,
                                                                                  fileId,
                                                                                  fileName,
                                                                              }) => {
    const removeFileFromContractTaskStatus = useSelector((state: AppState) => state.contract.removeFileFromContractTaskStatus);
    const dispatch: any = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(setRemoveFileFromContractTaskStatus(null));
        };
    }, [dispatch]);

    const handleDeleteClick = async () => {
        try {
            const result = await dispatch(removeFileFromContractAction({contractId: contractId, fileId}));
            if (result.type === 'contract/removeFileFromContract/fulfilled') {
                handleDelete();
                handleClose();
            }
        } catch (error) {
            console.error('Dosya silme işleminde bir hata oluştu:', error);
        }
    };

    return (
        <CustomDialog open={true} onClose={handleClose}>
            <DialogTitle>Dosyayı Sil ({fileName})</DialogTitle>
            <DialogContent>
                Bu dosyayı silmek istediğinizden emin misiniz?
                {removeFileFromContractTaskStatus?.type === AsyncTaskStatusType.Error &&
                    removeFileFromContractTaskStatus.errorMessage && (
                        <ErrorText type="form" message={removeFileFromContractTaskStatus.errorMessage}/>
                    )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>İptal</Button>
                <Button onClick={handleDeleteClick} color="error">
                    Sil
                </Button>
            </DialogActions>
        </CustomDialog>
    );
};
